import measurements from "./measurements"

export const columns = (val: number) => `${(val / 16) * 100}vw`

export const columns14 = (val: number) => `${(val / 14) * 100}vw`

export const columnsInMaxWidth = (val: number) =>
  `${val / 12} * ${measurements.MAX_WIDTH}`
